import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Logo, LogoWhite, MailIcon } from "../EntryFile/imagePath";
import { Helmet } from "react-helmet";
import { authenticateUser } from "../core/api/user";
import alertify from "alertifyjs";
import { useUser } from "../core/context/user";

const SignIn = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {user, updateUser } = useUser();
  const history = useHistory();

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await authenticateUser({ email, password });
      if (response.success) {
        alertify.success("Login successful");
        // Update user context
        updateUser(response.data.user);
        console.log(response.data.user, "user");
        // Save token to localStorage or context
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        // Redirect to dashboard
        history.push("/main/dashboard");
      } else {
        // Handle login failure (e.g., show error message)
        console.error("Login failed");
        alertify.error("Invalid email or password");
      }
    } catch (error) {
      console.error("Error during login:", error);
      alertify.error("Invalid email or password");

    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="main-wrapper">
      <Helmet>
        <title>Prime Precision Imaging | SignIn</title>
        <meta name="description" content="Sign in page" />
      </Helmet>
      <div className="account-content">
        <div className="login-wrapper login-new">
          <div className="container">
            <div className="login-content user-login">
              <div className="login-logo">
                <img src={Logo} alt="img" />
                <Link to="#" className="login-logo logo-white">
                  <img src={LogoWhite} alt="logo" />
                </Link>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="login-userset">
                  <div className="login-userheading">
                    <h3>Sign In</h3>
                    <h4>
                      Sign in to Prime Precision Imaging using your email and passcode.
                    </h4>
                  </div>
                  <div className="form-login">
                    <label className="form-label">Email Address</label>
                    <div className="form-addons">
                      <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <img src={MailIcon} alt="img" />
                    </div>
                  </div>
                  <div className="form-login">
                    <label>Password</label>
                    <div className="pass-group">
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        className="pass-input form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <span
                        className={`fas toggle-password ${
                          isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                        }`}
                        onClick={togglePasswordVisibility}
                      ></span>
                    </div>
                  </div>
                  <div className="form-login">
                    <button
                      type="submit"
                      className="btn btn-login"
                      disabled={!email || !password || isSubmitting}
                    >
                      {isSubmitting ? "Signing In..." : "Sign In"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
              <p>Copyright © 2024 Prime Precision Imaging All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;